import React from "react";

import {
  DISCOVER_CHATBOT_CARD_ART_ASPECT_RATIO,
  DISCOVER_CHATBOT_CARD_META_HEIGHT_PX,
  DISCOVER_CHATBOT_CARD_SURFACE_CLASS_NAME,
} from "@/pages/Discover/components/discoverChatbotCardDimensions";
import { cn } from "@/utils";

const SKELETON_CLASS_NAME = cn("flex w-full flex-col overflow-hidden", DISCOVER_CHATBOT_CARD_SURFACE_CLASS_NAME);
const PULSE_CLASS_NAME = "animate-pulse rounded bg-default-200 dark:bg-default-100";
const DESCRIPTION_LINE_WIDTHS = ["w-full", "w-[82%]", "w-[55%]"];
const ART_ASPECT_RATIO_STYLE = { aspectRatio: DISCOVER_CHATBOT_CARD_ART_ASPECT_RATIO };
const META_STYLE = { height: DISCOVER_CHATBOT_CARD_META_HEIGHT_PX };

/**
 * Loading placeholder sized to the final Discovery chatbot card (art + fixed
 * meta region + stat row) so cards do not jump when real data lands. No spinner.
 */
const DiscoverChatbotCardSkeleton = () => {
  return (
    <div data-testid="DiscoverChatbotCardSkeleton" className={SKELETON_CLASS_NAME}>
      <div className={`w-full ${PULSE_CLASS_NAME} rounded-none`} style={ART_ASPECT_RATIO_STYLE} />
      <div className="flex flex-col px-2 pt-1 pb-2">
        <div className="flex flex-col justify-start gap-1.5" style={META_STYLE}>
          {DESCRIPTION_LINE_WIDTHS.map((widthClassName) => (
            <div key={widthClassName} className={`h-[11px] ${widthClassName} ${PULSE_CLASS_NAME}`} />
          ))}
        </div>
        <div className={`mt-1.5 h-3 w-1/2 ${PULSE_CLASS_NAME}`} />
      </div>
    </div>
  );
};

export default React.memo(DiscoverChatbotCardSkeleton);
